import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { LOCALE_ID } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';

registerLocaleData(localePt, 'pt');

import { AppComponent } from './app.component';

import { P404Component } from './pages/error/404.component';
import { P500Component } from './pages/error/500.component';

import { CoreModule } from './core/core.module';
import { SharedModule } from './shared/shared.module';

// Import routing module
import { AppRoutingModule } from './app.routing';

import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';

import { AuthLayoutComponent } from './layouts/auth-layout/auth-layout.component';
import { TeacherLayoutComponent } from './layouts/teacher-layout/teacher-layout.component';
import { SiteLayoutComponent } from './layouts/site-layout/site-layout.component';
import { EmployeeLayoutComponent } from './layouts/employee-layout/employee-layout.component';
import { StudentLayoutComponent } from './layouts/student-layout/student-layout.component';
import { RegisterLayoutComponent } from './layouts/register-layout/register-layout.component';

import { ParticlesModule } from 'angular-particle';
import { RefreshComponent } from './pages/refresh/refresh.component';
import { IdleDetectDirective } from './shared/directives/idleDetect.directive';

import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { LevelingLayoutComponent } from './layouts/leveling-layout/leveling-layout.component';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true,
  wheelSpeed: 2,
  wheelPropagation: true,
  minScrollbarLength: 20
};

@NgModule({
  imports: [
    BrowserModule,
    CoreModule,    
    PerfectScrollbarModule,
    SharedModule.root(),
    AppRoutingModule,
    ParticlesModule,
    NgIdleKeepaliveModule.forRoot(),
  ],
  declarations: [
    AppComponent,    
    IdleDetectDirective,
    StudentLayoutComponent,
    SiteLayoutComponent,
    LevelingLayoutComponent,
    RegisterLayoutComponent,
    EmployeeLayoutComponent,
    TeacherLayoutComponent,    
    AuthLayoutComponent,
    P404Component,
    P500Component,
    RefreshComponent 
  ],
  providers: [
    { provide: LOCALE_ID, useValue: 'pt' },
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
    },
  ],
  bootstrap: [ AppComponent ]
})
export class AppModule { }
